import { isOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
const AFFECTED_CONTACT_PROPERTIES = ['hs_email_html'];
const fieldContainsAffectedContactProperty = field => AFFECTED_CONTACT_PROPERTIES.some(property => field === null || field === void 0 ? void 0 : field.name.includes(property));
export const isOperatorAffectedByEmailHTML = operator => {
  if (!isOperator(operator)) {
    return false;
  }
  return fieldContainsAffectedContactProperty(operator.field);
};